"use strict";

exports.__esModule = true;
exports["default"] = NavToggle;

var _react = _interopRequireDefault(require("react"));

var _coreSc = require("@smooth-ui/core-sc");

var _Close = _interopRequireDefault(require("./icons/Close"));

var _Menu = _interopRequireDefault(require("./icons/Menu"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Container = _coreSc.styled.div.withConfig({
  displayName: "NavToggle__Container",
  componentId: "e5ww14-0"
})(["position:relative;cursor:pointer;z-index:5;color:", ";svg{width:24px;height:24px;}", ""], (0, _coreSc.th)('primary'), (0, _coreSc.up)('md', 'display: none;'));

function NavToggle(_ref) {
  var toggled = _ref.toggled,
      onToggle = _ref.onToggle;
  return _react["default"].createElement(Container, {
    role: "button",
    onClick: onToggle
  }, toggled ? _react["default"].createElement(_Close["default"], null) : _react["default"].createElement(_Menu["default"], null));
}